export interface Manga {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverUrl: string;
  category: string;
  status: "连载中" | "已完结";
  rating: number;
  description: string;
  chapters: { title: string; number: number; date: string }[];
  tags: string[];
  views: number;
  updatedAt: string;
}

export const mangaList: Manga[] = [
  {
    id: "1",
    slug: "xinghe-zhilian",
    title: "星河之恋",
    author: "樱小路鹿乃子",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20manga%20cover%20style%20illustration%20of%20a%20couple%20under%20a%20starry%20night%20sky%2C%20soft%20watercolor%20texture%2C%20warm%20pink%20and%20gold%20tones%2C%20dreamy%20atmosphere%2C%20Japanese%20shoujo%20manga%20art%20style%2C%20delicate%20linework%2C%20subtle%20sparkle%20effects%2C%20clean%20composition%2C%20soft%20cream%20background&width=400&height=560&seq=manga-cover-01&orientation=portrait",
    category: "romance",
    status: "已完结",
    rating: 9.6,
    description: "在一个满天繁星的夜晚，高中生林星河遇见了转学生苏念。从那一刻起，命运的齿轮开始转动。这是一个关于青春、梦想与初恋的温暖故事，两颗心在星河之下慢慢靠近，共同谱写了一曲动人的恋歌。全篇画风细腻唯美，情感真挚动人，是近年来不可多得的纯爱佳作。",
    chapters: Array.from({ length: 48 }, (_, i) => ({
      title: i === 47 ? `第${i + 1}话 星河的尽头（大结局）` : `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 6) + 1)}-${String(10 + (i % 20)).padStart(2, "0")}`,
    })),
    tags: ["纯爱", "校园", "青春", "治愈"],
    views: 1285000,
    updatedAt: "2026-08-01",
  },
  {
    id: "2",
    slug: "yijie-zhi-wang",
    title: "异界之王",
    author: "墨染青衣",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20featuring%20a%20powerful%20magical%20warrior%20in%20ornate%20armor%2C%20swirling%20magical%20energy%2C%20epic%20fantasy%20illustration%2C%20dark%20and%20warm%20amber%20tones%2C%20dramatic%20lighting%2C%20clean%20cinematic%20composition%2C%20Japanese%20manga%20style%2C%20detailed%20linework%2C%20soft%20cream%20background&width=400&height=560&seq=manga-cover-02&orientation=portrait",
    category: "fantasy",
    status: "连载中",
    rating: 9.3,
    description: "普通上班族陆辰意外穿越到剑与魔法的世界，获得了独一无二的王之力。在这个强者为尊的异世界，他将如何一步步建立自己的王国？热血冒险与策略博弈交织，一个宏大的异世界史诗就此展开。",
    chapters: Array.from({ length: 126 }, (_, i) => ({
      title: `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 6) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["穿越", "热血", "冒险", "战斗"],
    views: 3560000,
    updatedAt: "2026-08-03",
  },
  {
    id: "3",
    slug: "mishi-zhi-cheng",
    title: "密室之城",
    author: "夜不语",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20manga%20cover%20with%20a%20shadowy%20figure%20in%20a%20dark%20corridor%2C%20mysterious%20atmosphere%2C%20warm%20sepia%20and%20dark%20umber%20tones%2C%20suspenseful%20composition%2C%20Japanese%20manga%20style%2C%20detailed%20linework%2C%20soft%20cream%20background%2C%20noir%20lighting&width=400&height=560&seq=manga-cover-03&orientation=portrait",
    category: "mystery",
    status: "已完结",
    rating: 9.5,
    description: "一场突如其来的密室杀人案，将十个陌生人困在了一座古老城堡中。每个人都有自己的秘密，而真相远比想象中更加残酷。层层反转，步步惊心，不到最后一页你绝对猜不到真凶是谁。被誉为近年来最精彩的悬疑漫画之一。",
    chapters: Array.from({ length: 36 }, (_, i) => ({
      title: i === 35 ? `第${i + 1}话 真相（大结局）` : `第${i + 1}话`,
      number: i + 1,
      date: `2025-${String(8 + (i % 5)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["推理", "悬疑", "密室", "反转"],
    views: 2890000,
    updatedAt: "2025-12-20",
  },
  {
    id: "4",
    slug: "fenghua-lu",
    title: "风华录",
    author: "画骨",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20traditional%20Chinese%20historical%20manga%20cover%20with%20elegant%20figures%20in%20flowing%20hanfu%20robes%2C%20classical%20Chinese%20ink%20painting%20style%2C%20warm%20gold%20and%20crimson%20accents%2C%20cherry%20blossom%20motifs%2C%20poetic%20atmosphere%2C%20refined%20composition%2C%20soft%20cream%20background&width=400&height=560&seq=manga-cover-04&orientation=portrait",
    category: "historical",
    status: "已完结",
    rating: 9.7,
    description: "大梁王朝，风华绝代。她是将门之女，他是冷面王爷。一场政治联姻，却成了刻骨铭心的爱恋。朝堂权谋与儿女情长交织，看这一对璧人如何在乱世中守护彼此，共同谱写一曲荡气回肠的古风传奇。画风绝美，每一页都如同水墨画般精致。",
    chapters: Array.from({ length: 72 }, (_, i) => ({
      title: i === 71 ? `第${i + 1}话 风华永驻（大结局）` : `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 4) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["古风", "权谋", "言情", "唯美"],
    views: 4520000,
    updatedAt: "2026-04-15",
  },
  {
    id: "5",
    slug: "chengshi-dianying",
    title: "城市电影",
    author: "夏天",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20modern%20urban%20slice-of-life%20manga%20cover%20showing%20young%20professionals%20in%20a%20cozy%20city%20cafe%2C%20warm%20coffee%20and%20wood%20tones%2C%20relaxed%20atmosphere%2C%20Japanese%20manga%20style%2C%20clean%20composition%2C%20soft%20cream%20background%2C%20lifestyle%20aesthetic&width=400&height=560&seq=manga-cover-05&orientation=portrait",
    category: "urban",
    status: "连载中",
    rating: 9.1,
    description: "四个在大城市打拼的年轻人的日常故事。有欢笑，有泪水，有迷茫，也有成长。在这座永不眠的城市里，他们互相扶持，一起追逐各自的梦想。朴实无华却温暖人心，每个读者都能在故事中找到自己的影子。",
    chapters: Array.from({ length: 84 }, (_, i) => ({
      title: `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 6) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["都市", "日常", "成长", "治愈"],
    views: 1560000,
    updatedAt: "2026-08-02",
  },
  {
    id: "6",
    slug: "shaonv-richang",
    title: "少女日常",
    author: "七濑葵",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20cute%20comedy%20manga%20cover%20with%20three%20high%20school%20girls%20laughing%20together%2C%20bright%20and%20cheerful%20illustration%2C%20warm%20pastel%20peach%20and%20coral%20tones%2C%20Japanese%20manga%20style%2C%20expressive%20faces%2C%20clean%20composition%2C%20soft%20cream%20background&width=400&height=560&seq=manga-cover-06&orientation=portrait",
    category: "comedy",
    status: "连载中",
    rating: 9.0,
    description: "三个性格迥异的女高中生的快乐日常！天然呆的小萌，毒舌又傲娇的阿梓，还有永远在状况外的吃货小圆。她们的每一天都充满了意想不到的笑料和温馨时刻。解压神作，笑到肚子疼！",
    chapters: Array.from({ length: 56 }, (_, i) => ({
      title: `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 6) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["搞笑", "校园", "日常", "轻松"],
    views: 980000,
    updatedAt: "2026-07-30",
  },
  {
    id: "7",
    slug: "longshen-jianglin",
    title: "龙神降临",
    author: "极光",
    coverUrl: "https://readdy.ai/api/search-image?query=An%20action%20manga%20cover%20with%20a%20dragon%20warrior%20in%20dynamic%20battle%20pose%2C%20flames%20and%20energy%20effects%2C%20warm%20crimson%20and%20gold%20tones%2C%20intense%20composition%2C%20Japanese%20shounen%20manga%20style%2C%20dramatic%20lighting%2C%20clean%20cream%20background&width=400&height=560&seq=manga-cover-07&orientation=portrait",
    category: "action",
    status: "连载中",
    rating: 9.4,
    description: "传说龙神的力量沉睡在少年体内，当世界面临危机时，这股力量觉醒了！一拳碎石，一吼惊天，看少年如何驾驭龙神之力，守护这个摇摇欲坠的世界。战斗场面震撼燃爆，每一帧都可以做壁纸！",
    chapters: Array.from({ length: 168 }, (_, i) => ({
      title: `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 6) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["热血", "战斗", "龙", "超能力"],
    views: 5120000,
    updatedAt: "2026-08-03",
  },
  {
    id: "8",
    slug: "guiwu-zhiye",
    title: "鬼屋之夜",
    author: "黑泽",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20horror%20manga%20cover%20with%20a%20creepy%20haunted%20house%20silhouette%20under%20moonlight%2C%20eerie%20atmosphere%2C%20dark%20umber%20and%20warm%20sepia%20tones%2C%20subtle%20red%20accents%2C%20Japanese%20horror%20manga%20style%2C%20ominous%20composition%2C%20clean%20cream%20background&width=400&height=560&seq=manga-cover-08&orientation=portrait",
    category: "horror",
    status: "已完结",
    rating: 9.2,
    description: "六个大学生在暑假期间前往一座废弃的古老宅邸探险。他们以为这只是一次刺激的冒险，却不知道这座房子藏着不可告人的秘密。当夜晚降临，真正的恐怖才刚刚开始……每翻一页都在挑战你的胆量极限。",
    chapters: Array.from({ length: 24 }, (_, i) => ({
      title: i === 23 ? `第${i + 1}话 黎明（大结局）` : `第${i + 1}话`,
      number: i + 1,
      date: `2025-10-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["恐怖", "灵异", "惊悚", "校园"],
    views: 1890000,
    updatedAt: "2025-10-24",
  },
  {
    id: "9",
    slug: "tianshi-zhi-wen",
    title: "天使之吻",
    author: "花泽千春",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20romance%20manga%20cover%20with%20an%20angel-themed%20couple%2C%20feathers%20floating%2C%20soft%20warm%20rose%20and%20peach%20tones%2C%20dreamy%20ethereal%20atmosphere%2C%20Japanese%20shoujo%20manga%20style%2C%20delicate%20linework%2C%20soft%20cream%20background&width=400&height=560&seq=manga-cover-09&orientation=portrait",
    category: "romance",
    status: "已完结",
    rating: 9.5,
    description: "天野优姬是校园里最不起眼的女生，而她的同班同学却是全校女生心目中的白马王子——如月莲。一次偶然的相撞，让两人的命运产生了交集。这是一个关于暗恋成真的甜蜜故事，纯到让人心都化了。",
    chapters: Array.from({ length: 32 }, (_, i) => ({
      title: i === 31 ? `第${i + 1}话 天使的约定（大结局）` : `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 3) + 1)}-${String(10 + (i % 20)).padStart(2, "0")}`,
    })),
    tags: ["纯爱", "校园", "甜宠", "少女"],
    views: 2340000,
    updatedAt: "2026-03-28",
  },
  {
    id: "10",
    slug: "yijie-shangdian",
    title: "异界商店",
    author: "白夜",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20whimsical%20fantasy%20manga%20cover%20showing%20a%20magical%20shop%20with%20mysterious%20items%20on%20shelves%2C%20warm%20amber%20and%20gold%20lighting%2C%20cozy%20atmosphere%2C%20Japanese%20manga%20style%2C%20detailed%20interior%2C%20soft%20cream%20background&width=400&height=560&seq=manga-cover-10&orientation=portrait",
    category: "fantasy",
    status: "连载中",
    rating: 9.3,
    description: "在异世界的角落，有一家神奇的商店，里面出售着来自各个世界的奇妙商品。店主是一位看似普通却身怀绝技的神秘青年。每一个走进这家店的客人，都将开启一段不可思议的冒险。温馨治愈又脑洞大开的奇幻佳作。",
    chapters: Array.from({ length: 92 }, (_, i) => ({
      title: `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 6) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["奇幻", "治愈", "日常", "冒险"],
    views: 2010000,
    updatedAt: "2026-07-28",
  },
  {
    id: "11",
    slug: "zhenxiang-youxi",
    title: "真相游戏",
    author: "暗夜公爵",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20psychological%20thriller%20manga%20cover%20with%20a%20chess%20board%20and%20shadowy%20figures%2C%20dark%20warm%20umber%20and%20amber%20tones%2C%20mind%20game%20vibe%2C%20Japanese%20seinen%20manga%20style%2C%20dramatic%20composition%2C%20soft%20cream%20background&width=400&height=560&seq=manga-cover-11&orientation=portrait",
    category: "mystery",
    status: "连载中",
    rating: 9.4,
    description: "一款神秘的手机App突然在校园中流行起来——「真相游戏」。只要完成App中的任务，就能获得关于任何人的一个真相。然而，当真相的代价开始显现，这场游戏逐渐失控。心理博弈的极致之作，看完直呼过瘾！",
    chapters: Array.from({ length: 64 }, (_, i) => ({
      title: `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 5) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["悬疑", "心理", "游戏", "校园"],
    views: 2670000,
    updatedAt: "2026-08-01",
  },
  {
    id: "12",
    slug: "jianghu-xing",
    title: "江湖行",
    author: "水墨丹青",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20wuxia%20manga%20cover%20with%20swordsmen%20in%20flowing%20robes%20amidst%20bamboo%20forest%2C%20classical%20ink%20wash%20painting%20style%2C%20warm%20gold%20and%20crimson%20accents%2C%20poetic%20composition%2C%20soft%20cream%20background&width=400&height=560&seq=manga-cover-12&orientation=portrait",
    category: "historical",
    status: "已完结",
    rating: 9.8,
    description: "江湖是什么？是快意恩仇的刀光剑影，也是柔情似水的儿女情长。少年剑客叶孤云从深山走出，踏入这纷繁复杂的江湖世界。一路行来，有挚友相伴，有红颜相知，也有宿敌相争。这部作品被誉为十年最佳武侠漫画，画风与剧情俱佳。",
    chapters: Array.from({ length: 96 }, (_, i) => ({
      title: i === 95 ? `第${i + 1}话 江湖再见（大结局）` : `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 5) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["武侠", "江湖", "古风", "热血"],
    views: 5890000,
    updatedAt: "2026-05-30",
  },
  {
    id: "13",
    slug: "yexing-dushi",
    title: "夜行都市",
    author: "流云",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20noir%20urban%20manga%20cover%20with%20a%20solitary%20figure%20walking%20through%20rainy%20city%20streets%20at%20night%2C%20warm%20amber%20streetlight%20reflections%2C%20melancholic%20atmosphere%2C%20Japanese%20seinen%20manga%20style%2C%20clean%20composition%2C%20soft%20cream%20background&width=400&height=560&seq=manga-cover-13&orientation=portrait",
    category: "urban",
    status: "连载中",
    rating: 9.0,
    description: "在这个城市的暗处，有一些人只在夜晚活动。他们可能是调酒师、出租车司机、便利店店员，也可能是守护这座城市的无名英雄。十二个夜晚，十二个故事，交织成一幅都市浮世绘。深夜治愈系，每一话都是一个独立又相连的短篇。",
    chapters: Array.from({ length: 40 }, (_, i) => ({
      title: `第${i + 1}夜`,
      number: i + 1,
      date: `2026-0${((i % 4) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["都市", "治愈", "短篇", "温情"],
    views: 890000,
    updatedAt: "2026-07-25",
  },
  {
    id: "14",
    slug: "baojun-daren",
    title: "暴君大人",
    author: "猫薄荷",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20funny%20comedy%20manga%20cover%20with%20an%20over-the-top%20boss%20character%20making%20exaggerated%20expressions%2C%20bright%20warm%20coral%20and%20peach%20tones%2C%20hilarious%20composition%2C%20Japanese%20gag%20manga%20style%2C%20expressive%20art%2C%20soft%20cream%20background&width=400&height=560&seq=manga-cover-14&orientation=portrait",
    category: "comedy",
    status: "连载中",
    rating: 8.9,
    description: "史上最奇葩的老板——暴君大人！对员工要求极其严苛，但却总是莫名其妙地做出让人啼笑皆非的事情。社畜们的血泪日常被画成了爆笑漫画，笑着笑着就哭了，哭着哭着又笑了。打工人必看！",
    chapters: Array.from({ length: 88 }, (_, i) => ({
      title: `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 6) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["搞笑", "职场", "日常", "吐槽"],
    views: 3120000,
    updatedAt: "2026-08-03",
  },
  {
    id: "15",
    slug: "liehuo-zhanji",
    title: "烈火战纪",
    author: "赤焰",
    coverUrl: "https://readdy.ai/api/search-image?query=An%20explosive%20action%20manga%20cover%20with%20warriors%20in%20epic%20battle%2C%20flames%20and%20debris%2C%20warm%20crimson%20and%20gold%20tones%2C%20dynamic%20composition%2C%20Japanese%20shounen%20manga%20style%2C%20intense%20energy%2C%20clean%20cream%20background&width=400&height=560&seq=manga-cover-15&orientation=portrait",
    category: "action",
    status: "已完结",
    rating: 9.6,
    description: "在这场席卷大陆的烈火战争中，没有人能够独善其身。七位被选中的战士，各自背负着不同的使命与过去，在战火中相遇、成长、牺牲。宏大的战争场面，细腻的人物刻画，这是一部会让你热血沸腾又泪流满面的史诗级战斗漫画。",
    chapters: Array.from({ length: 144 }, (_, i) => ({
      title: i === 143 ? `第${i + 1}话 余烬（大结局）` : `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 4) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["战斗", "战争", "热血", "史诗"],
    views: 6780000,
    updatedAt: "2026-04-20",
  },
  {
    id: "16",
    slug: "linghun-baibei",
    title: "灵魂摆渡",
    author: "幽明",
    coverUrl: "https://readdy.ai/api/search-image?query=A%20supernatural%20horror%20manga%20cover%20with%20a%20ferryman%20on%20a%20misty%20river%2C%20ghostly%20figures%2C%20eerie%20warm%20sepia%20and%20dark%20umber%20tones%2C%20Japanese%20horror%20manga%20style%2C%20atmospheric%20composition%2C%20soft%20cream%20background&width=400&height=560&seq=manga-cover-16&orientation=portrait",
    category: "horror",
    status: "连载中",
    rating: 9.1,
    description: "你能看见鬼吗？少女苏晚不仅能看见，还能与它们交流。在一次意外中，她成为了一名灵魂摆渡人——帮助那些无法安息的灵魂完成未了的心愿。每一个灵魂背后都有一段令人动容的故事。灵异外壳下是温暖的人性内核。",
    chapters: Array.from({ length: 52 }, (_, i) => ({
      title: `第${i + 1}话`,
      number: i + 1,
      date: `2026-0${((i % 6) + 1)}-${String(1 + (i % 28)).padStart(2, "0")}`,
    })),
    tags: ["灵异", "治愈", "温情", "短篇集"],
    views: 1450000,
    updatedAt: "2026-07-31",
  },
];

export const getMangaByCategory = (categorySlug: string): Manga[] => {
  return mangaList.filter((m) => m.category === categorySlug);
};

export const getMangaBySlug = (slug: string): Manga | undefined => {
  return mangaList.find((m) => m.slug === slug);
};

export const getHotManga = (): Manga[] => {
  return [...mangaList].sort((a, b) => b.views - a.views).slice(0, 8);
};

export const getLatestManga = (): Manga[] => {
  return [...mangaList].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);
};

export const getCompletedManga = (): Manga[] => {
  return mangaList.filter((m) => m.status === "已完结").slice(0, 8);
};